export default __webpack_public_path__ + "static/media/youhuiquan.f117a833.png";